import { render, staticRenderFns } from "./Materiais.vue?vue&type=template&id=1811c35a&scoped=true&"
import script from "./Materiais.vue?vue&type=script&lang=js&"
export * from "./Materiais.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1811c35a",
  null
  
)

export default component.exports